export * from './ProxyFrameOAuth.interface';
export * from './ProxyFrameOAuth';
export { ProxyFrameOAuth as default } from './ProxyFrameOAuth';
